// polyfill taken from https://github.com/ungap/random-uuid/blob/main/index.js
if (crypto && !('randomUUID' in crypto)) {
  // https://stackoverflow.com/a/2117523/2800218
  // LICENSE: https://creativecommons.org/licenses/by-sa/4.0/legalcode
  // @ts-expect-error Property 'randomUUID' does not exist on type 'never'.ts(2339)
  crypto.randomUUID = function randomUUID() {
    // @ts-expect-error Operator '+' cannot be applied to types 'number[]' and 'number'.ts(2365)
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
    )
  }
}
